import { UIElement } from "@finn-no/pulse-sdk/dist/types";
import pulse from "@finn-no/pulse-sdk";
import { NotificationChannels, TrackedChannel } from "./model/model";
import { TrackingMapper } from "./mappers/TrackingMapper";

enum Action {
  OPEN = "OPEN",
  SAVE = "SAVE",
  DELETE = "DELETE",
}

type PulseTrackingType = "Edit" | "Confirm" | "Delete";

type TrackedChanges = TrackedChannel[] | ["delete"];

const actionToIntent: Record<Action, PulseTrackingType> = {
  [Action.OPEN]: "Edit",
  [Action.SAVE]: "Confirm",
  [Action.DELETE]: "Delete",
};

const createTrackingObject = (trackedChanges?: TrackedChanges): UIElement => {
  const changes: string | undefined = trackedChanges
    ?.map((change) => change.toLowerCase())
    .sort()
    .join(",");

  const baseTrackingData = { type: "UIElement" } as UIElement;
  return changes ? { ...baseTrackingData, name: changes } : baseTrackingData;
};

const trackToPulse = (action: Action, changes?: TrackedChanges): void => {
  const trackerData = {
    name: "Notifications: saved search",
    type: "Click" as const,
    vertical: {
      name: "common_pages",
      subVertical: "notifications",
    },
    intent: actionToIntent[action],
    object: createTrackingObject(changes),
  };

  pulse.trackEvent(trackerData);
};

export const trackSavedSearchSettings = {
  open: () => trackToPulse(Action.OPEN),

  update: (notifications: NotificationChannels) =>
    trackToPulse(
      Action.SAVE,
      TrackingMapper.notificationChannelsToTrackedChannels(notifications)
    ),

  delete: () => trackToPulse(Action.DELETE, ["delete"]),
};
